var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 18,
    viewBox: "0 0 4 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.50341 0.0623911C0.445605 0.336426 -0.208852 1.39145 0.0606993 2.38829C0.339804 3.42049 1.43345 4.05721 2.4774 3.79528C3.54584 3.52719 4.20989 2.47276 3.93967 1.47343C3.65802 0.43183 2.55145 -0.209112 1.50341 0.0623911ZM1.50341 7.13529C0.445605 7.40933 -0.208852 8.46435 0.0606993 9.46119C0.339804 10.4934 1.43345 11.1301 2.4774 10.8682C3.54584 10.6001 4.20989 9.54566 3.93967 8.54634C3.65802 7.50473 2.55145 6.86379 1.50341 7.13529ZM1.50341 14.2082C0.445605 14.4822 -0.208852 15.5373 0.0606993 16.5341C0.339804 17.5663 1.43345 18.203 2.4774 17.9411C3.54584 17.673 4.20989 16.6186 3.93967 15.6192C3.65802 14.5776 2.55145 13.9367 1.50341 14.2082Z",
    fill: "#1E1E1E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrace);
export default __webpack_public_path__ + "static/media/trace.999b5cf76b329112d830dd6cbf2aef66.svg";
export { ForwardRef as ReactComponent };